module.exports = __webpack_public_path__ + "static/media/advBanner.d2019e78.png";